// extracted by mini-css-extract-plugin
export default {"legend-color":"m0Qum","legend":"ibaF8"};